import React, { useState, useEffect, useRef } from "react";
import SecurityScanPage from "./SecurityScanPage";
import "./App.css";



// QRCode library from CDN
const loadQRCode = () => {
  if (!window.QRCode) {
    const script = document.createElement('script');
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
    document.body.appendChild(script);
  }
};

function App() {
  // Page states
  const [page, setPage] = useState('login'); // login, dashboard, sticker, qrvalidation
  const [loggedIn, setLoggedIn] = useState(false);

  // Sticker Generator states
  
  const [storeName, setStoreName] = useState('');
  const [showStoreInput, setShowStoreInput] = useState(false);
  const [storeInput, setStoreInput] = useState('');
  const [sto, setSto] = useState('STO123456');
  const [category, setCategory] = useState('ABC');
  const [date, setDate] = useState('');
  const [qty, setQty] = useState('250');
  const [bundle, setBundle] = useState(15);
  const [rpn, setRpn] = useState('');
  const [rpnSelect, setRpnSelect] = useState('');
  const [showPrintBtn, setShowPrintBtn] = useState(false);

  const categoryList = [
  "BACK TO SCHOOL",
  "BAGS",
  "BAGS ACCESS",
  "BATTERY TOYS",
  "BED LINEN",
  "BED SHEETS",
  "BOYS ACTIVE WEAR",
  "BOYS BOTTOM",
  "BOYS ETHNIC WEAR",
  "BOYS FOOTWEAR",
  "BOYS SET",
  "BOYS TOP",
  "DOLLS",
  "FIGURE TOYS",
  "GAMING",
  "GIRLS ACTIVE WEAR",
  "GIRLS BOTTOM",
  "GIRLS ETHNIC WEAR",
  "GIRLS FOOTWEAR",
  "GIRLS TOP",
  "GIRLS WESTERN WEAR",
  "HOUSE KEEPING ITEMS",
  "INFANT TOP",
  "LUGGAGE",
  "MAINTENANCE SERVICE",
  "MEN ACCESSORIES",
  "MEN ACTIVE WEAR",
  "MEN BOTTOM",
  "MEN ETHNIC WEAR",
  "MEN FABRIC",
  "MEN FOOTWEAR",
  "MEN INNER WEAR",
  "MEN NIGHT WEAR",
  "MEN SUIT N BLAZER",
  "MEN TOP",
  "MEN WINTER WEAR",
  "PRINTING & STATIONARY",
  "PROTECTIVE WEAR",
  "SAREES",
  "SILK",
  "SPORTS",
  "TOYS",
  "WOMEN BOTTOM",
  "WOMEN ETHNIC WEAR",
  "WOMEN FOOTWEAR",
  "WOMEN INNER WEAR",
  "WOMEN MIX N MATCH",
  "WOMEN NIGHT WEAR",
  "WOMEN TOP"
];


  // QR Validation states
  const [qrStore, setQrStore] = useState('');
  const [tagNo, setTagNo] = useState('');
  const [qrInput, setQrInput] = useState('');
  const [items, setItems] = useState([]);
  const [serial, setSerial] = useState(0);
  const [locked, setLocked] = useState(false);
  const [adminMode, setAdminMode] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [qrStoreSelect, setQrStoreSelect] = useState('');
const [qrStoreManual, setQrStoreManual] = useState('');

const handleQrStoreChange = (e) => {
  const val = e.target.value;
  setQrStoreSelect(val);

  if (val === "MANUAL") {
    setQrStore(""); // clear until manual typed
  } else {
    setQrStore(val);
  }
};



  useEffect(() => {
    // Auto-fill date for sticker
    const d = new Date();
    setDate(
      String(d.getDate()).padStart(2, '0') +
        '-' +
        String(d.getMonth() + 1).padStart(2, '0') +
        '-' +
        d.getFullYear()
    );

    loadQRCode();
  }, []);

  // LOGIN FUNCTIONS
  const login = (userid, password) => {
    if (userid === 'imkty' && password === '100') {
      setLoggedIn(true);
      setPage('dashboard');
    } else alert('Invalid Login');
  };

  const logout = () => {
    setLoggedIn(false);
    setPage('login');
  };

  /// im return here !!!

  const submitToServer = async () => {

  if (!qrStore.trim()) {
    alert("Enter Store Name");
    return;
  }

  if (items.length === 0) {
    alert("No data to submit");
    return;
  }

  let csv = 'Store Name:,' + qrStore + '\n';
  csv += 'Tag No:,' + tagNo + '\n\n';
  csv += 'S.No,STO,Category,RPN,Total,Scanned,Status\n';

  items.forEach((i) => {
    const status =
      i.scannedBundles.length === i.total ? 'Complete' : 'Incomplete';

    csv += `${i.serial},${i.STO},${i.Category},${i.RPN},${i.total},${i.scannedBundles.length},${status}\n`;
  });

  const blob = new Blob([csv], { type: 'text/csv' });

  const formData = new FormData();
  const fileName = `${qrStore}_${tagNo}_${Date.now()}.csv`;
  formData.append("file", blob, fileName);

  try {
    //https://api.sysfileinfo.online
    const response = await fetch("https://dispatch.us.cc/api/uploadExcel", {
      method: "POST",
      body: formData
    });

    const result = await response.text();

    alert("✅ Submitted Successfully!\n" + result);

    // ✅ CLEAR ALL SCANNED DATA (IMPORTANT FIX)
    setItems([]);
    setSerial(0);
    setLocked(false);
    setQrStore("");
    setTagNo("");
    setQrInput("");

  } catch (error) {

    alert("❌ Server not reachable!");

  }
};


  // STICKER GENERATOR FUNCTIONS
  const handleStoreChange = (e) => {
    const val = e.target.value;
    setStoreName(val);
    setShowStoreInput(val === 'OTHER');
    if (val !== 'OTHER') setStoreInput(val);
  };

  const handleRpnChange = (e) => {
    const val = e.target.value;
    setRpnSelect(val);
    if (val === 'MANUAL') {
      setRpn('');
    } else {
      setRpn(val);
    }
  };

  const generateStickers = () => {
    const finalStore = storeName === 'OTHER' ? storeInput.trim() : storeName;
    if (!finalStore) return alert('Select Store Name');
    if (!rpn) return alert('Select or enter RPN');

    const printArea = document.getElementById('printArea');
    printArea.innerHTML = '';

    for (let i = 1; i <= bundle; i++) {
      const s = document.createElement('div');
      s.className = 'sticker';
      s.innerHTML = `
        <div class="header">${finalStore}</div>
        <div class="middle">
          <div class="qr-box"><div id="qr-${i}"></div></div>
          <div class="info">
            <div class="info-row">STO NO : ${sto}</div>
            <div class="info-row">CATEGORY : ${category}</div>
            <div class="info-row">DATE : ${date}</div>
            <div class="info-row">QTY : ${qty}</div>
          </div>
        </div>
        <div class="footer">
          <span>TOTAL BUNDLE : ${i}/${bundle}</span>
          <span>RPN: ${rpn}</span>
        </div>
      `;
      printArea.appendChild(s);
      new window.QRCode(document.getElementById(`qr-${i}`), {
        text: `${i}/${bundle}|${sto}|${category}|${qty}|${rpn}`,

        width: 140,
        height: 140,
        correctLevel: window.QRCode.CorrectLevel.H,
      });
    }

    console.log("Setting print button true");

    setShowPrintBtn(true);
  };

  // QR VALIDATION FUNCTIONS
  const allowedRPN = ['STOS1', 'STOS2', 'STOS3'];

  const processQR = (qr) => {
    if (!qr) return;
    if (!qrStore.trim()) {
      setErrorMsg('Enter Store Name first!');
      setTimeout(() => setErrorMsg(''), 3000);
      return;
    }

    const parts = qr.split('|');
    if (parts.length < 5) {
      setErrorMsg('Invalid QR format!');
      setTimeout(() => setErrorMsg(''), 3000);
      return;
    }

    const [bundleInfo, STO, category, qtyVal, RPN] = parts;
    const [bundleNo, totalBundles] = bundleInfo.split('/').map(Number);

    // ❌ Invalid bundle number check
    if (bundleNo > totalBundles || bundleNo <= 0) {
      setErrorMsg(`Invalid bundle number ${bundleNo}/${totalBundles}`);
      setTimeout(() => setErrorMsg(''), 3000);
      return;
    }

    if (!allowedRPN.includes(RPN)) {
      setErrorMsg('Invalid RPN! Only STOS1, STOS2, STOS3 allowed.');
      setTimeout(() => setErrorMsg(''), 3000);
      return;
    }

    const existing = items.find((i) => i.STO === STO);

    if (existing) {
      if (existing.RPN !== RPN) {
        setErrorMsg('RPN mismatch for same STO!');
        setTimeout(() => setErrorMsg(''), 3000);
        return;
      }
      if (existing.Category !== category) {
        setErrorMsg('Category mismatch for same STO!');
        setTimeout(() => setErrorMsg(''), 3000);
        return;
      }
      if (existing.total !== totalBundles) {
        setErrorMsg('Total bundle mismatch!');
        setTimeout(() => setErrorMsg(''), 3000);
        return;
      }
      if (existing.scannedBundles.includes(bundleNo)) {
        setErrorMsg(`Bundle ${bundleNo} already scanned!`);
        setTimeout(() => setErrorMsg(''), 3000);
        return;
      }

      if (existing.scannedBundles.length >= existing.total) {
        setErrorMsg('All bundles already scanned for this STO!');
        setTimeout(() => setErrorMsg(''), 3000);
        return;
      }

      existing.scannedBundles.push(bundleNo);
      setItems([...items]);
    } else {
      const newItem = {
        serial: serial + 1,
        STO,
        Category: category,
        RPN,
        total: totalBundles,
        scannedBundles: [bundleNo],
      };
      setItems([...items, newItem]);
      setSerial(serial + 1);
    }
    if (!locked && items.length === 0) {
      setLocked(true);
    }
  };

  const handleQRKeyPress = (e) => {
    if (e.key === 'Enter') {
      processQR(qrInput.trim());
      setQrInput('');
    }
  };

  const deleteRow = (index) => {
    if (!adminMode) return;

    const newItems = [...items];
    newItems.splice(index, 1);
    newItems.forEach((item, i) => (item.serial = i + 1));

    setItems(newItems);
    setSerial(newItems.length);

    if (newItems.length === 0) {
      setLocked(false); // 🔓 Auto unlock when empty
    }
  };

  const adminUnlock = () => {
    if (adminMode) {
      setAdminMode(false);
      return alert('Admin Mode Disabled 🔒');
    }
    const pass = prompt('Enter Admin Password:');
    if (pass === 'admin123') {
      setAdminMode(true);
      return alert('Admin Mode Enabled 🔓');
    }
    alert('Wrong Password!');
  };

  const downloadExcel = () => {
    let csv = 'Store Name:,' + qrStore + '\n';
    csv += 'Tag No:,' + tagNo + '\n\n';
    csv += 'S.No,STO,Category,RPN,Total,Scanned,Status\n';
    items.forEach((i) => {
      const status =
        i.scannedBundles.length === i.total ? 'Complete' : 'Incomplete';
      csv += `${i.serial},${i.STO},${i.Category},${i.RPN},${i.total},${i.scannedBundles.length},${status}\n`;
    });
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'QR_Report.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  // RENDER PAGES
  if (page === 'login') return <LoginPage onLogin={login} />;

  if (page === 'dashboard')
    return <DashboardPage logout={logout} goToPage={setPage} />;

  if (page === 'securityscan')
  return <SecurityScanPage goToPage={setPage} />;

  if (page === 'uploader')
  return <Uploader goToPage={setPage} />;



  if (page === 'sticker')
    return (
      <StickerGenerator
        goToPage={setPage}
        storeName={storeName}
        handleStoreChange={handleStoreChange}
        showStoreInput={showStoreInput}
        storeInput={storeInput}
        setStoreInput={setStoreInput}
        sto={sto}
        setSto={setSto}
        category={category}
        setCategory={setCategory}
        categoryList={categoryList}
        date={date}
        setDate={setDate}
        qty={qty}
        setQty={setQty}
        bundle={bundle}
        setBundle={setBundle}
        rpn={rpn}
        rpnSelect={rpnSelect}
        handleRpnChange={handleRpnChange}
        setRpn={setRpn}
        generateStickers={generateStickers}
        showPrintBtn={showPrintBtn}
      />
    );

  if (page === 'qrvalidation')
  return (
    <QRValidation
  goToPage={setPage}

  qrStore={qrStore}
  setQrStore={setQrStore}

  qrStoreSelect={qrStoreSelect}
  setQrStoreSelect={setQrStoreSelect}

  qrStoreManual={qrStoreManual}
  setQrStoreManual={setQrStoreManual}

  handleQrStoreChange={handleQrStoreChange}

  tagNo={tagNo}
  setTagNo={setTagNo}

  qrInput={qrInput}
  setQrInput={setQrInput}

  items={items}
  deleteRow={deleteRow}
  adminUnlock={adminUnlock}
  adminMode={adminMode}
  processQR={processQR}
  handleQRKeyPress={handleQRKeyPress}
  downloadExcel={downloadExcel}
  errorMsg={errorMsg}
  locked={locked}

  submitToServer={submitToServer}
/>

  );


  return null;
}

// LOGIN COMPONENT
function LoginPage({ onLogin }) {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
  document.title = "Master Login"; // any name you like
}, []);

  return (
    <div className="login-page" 
  style={{
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: "url('/obicon.png')",
    backgroundSize: '60%', 
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}>
      <div className="login-card">
        <h2>LOGIN</h2>
        <div className="input-group">
          <input
            placeholder="User ID"
            value={userid}
            onChange={(e) => setUserid(e.target.value)}
          />
          <div className="light-bar"></div>
        </div>
        <div className="input-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div className="light-bar"></div>
        </div>
        <button className="login-btn" onClick={() => onLogin(userid, password)}>
          Login
        </button>
      </div>
    </div>
  );
}

// DASHBOARD COMPONENT
function DashboardPage({ logout, goToPage }) {

  useEffect(() => {
  document.title = "Sticker & QR Dashboard"; // any name you like
}, []);


  return (
    
    <div className="dashboard" style={{backgroundImage: "url('/obicon.png')",
    backgroundSize: '70%', 
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',}} >
      <div className="top-bar">
        <h1>Welcome to Dashboard</h1>
        <button className="logout-btn" onClick={logout}>
  <span className="logout-text">LOGOUT</span>
  <span className="logout-icon">🔙</span>
</button>

      </div>
      <div className="dashboard-grid">
        <div className="card-box" onClick={() => goToPage('sticker')}>
          🖨<h2>Sticker Generator</h2>
        </div>
        <div className="card-box" onClick={() => goToPage('qrvalidation')}>
          📷<h2>QR Validation</h2>
        </div>
        <div className="card-box" onClick={() => goToPage('securityscan')}><h2>
          Security Scan
        </h2>
  
</div>
<div className="card-box" onClick={() => goToPage('uploader')}><h2>Uploader</h2>
</div>

      
      </div>
    </div>
  );
}

// security page 

function SecurityScan({ goToPage }) {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Security Scan Page</h2>

      <button onClick={() => goToPage('dashboard')}>
        Back to Dashboard
      </button>
    </div>
  );
}

//UPLOADER PAGE

function Uploader({ goToPage }) {
  const [files, setFiles] = useState([]);
  const [logs, setLogs] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");

  const deleteConfirm = (fileName, time) => {
    const password = prompt("Enter admin password");
    if (!password) return;

    fetch(
      `https://dispatch.us.cc/api/log/delete-confirm?fileName=${fileName}&time=${time}&password=${password}`,
      { method: "POST" }
    )
      .then((res) => res.text())
      .then((msg) => {
        if (msg === "Deleted") {
          alert("Deleted successfully");
          fetchLogs();
        } else {
          alert("Wrong password");
        }
      });
  };

  useEffect(() => {
    fetchFiles();
    fetchLogs();
  }, []);

  // Fetch files excluding validated ones
  const fetchFiles = () => {
    fetch("https://dispatch.us.cc/api/files/list")
      .then((res) => res.json())
      .then((data) => {
        // Remove validated files
        const available = data.filter((f) => !f.validated); // backend should mark validated files with validated=true
        setFiles(available);
      });
  };

  const fetchLogs = () => {
  fetch("https://dispatch.us.cc/api/log/list")
    .then((res) => res.json())
    .then((data) => {

      // get validated file names
      const validatedFiles = data
        .filter((log) => log.includes("|VALIDATED|"))
        .map((log) => log.split("|")[0]);

      // remove CONFIRMED logs of validated files
      const filteredLogs = data.filter((log) => {
        const [fileName, type] = log.split("|");

        if (validatedFiles.includes(fileName)) {
          return false; // hide all logs of validated file
        }

        return true;
      });

      // sort CONFIRMED first
      const sortedLogs = filteredLogs.sort((a, b) => {
        const isAConfirm = a.includes("|CONFIRMED|") ? 1 : 0;
        const isBConfirm = b.includes("|CONFIRMED|") ? 1 : 0;
        return isBConfirm - isAConfirm;
      });

      setLogs(sortedLogs);
    });
};

  const handleSelect = (e) => setSelectedFile(e.target.value);

  const confirmSelection = () => {
    if (!selectedFile) {
      alert("Select file first");
      return;
    }

    localStorage.setItem("selectedDispatchFile", selectedFile);

    fetch("https://dispatch.us.cc/api/log/confirm?fileName=" + selectedFile, {
      method: "POST",
    }).then(() => {
      alert("Confirmed!");
      fetchLogs();
      fetchFiles();
    });
  };

  return (
    <div style={{ padding: "15px", maxWidth: "1000px", margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <h2 style={{ flex: "1 1 auto", minWidth: "200px" }}>Uploader Page</h2>
        <button
          style={{
            flex: "0 0 auto",
            padding: "8px 12px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={() => goToPage("dashboard")}
        >
          Back
        </button>
      </div>

      {/* Available Files Dropdown */}
      <div style={{ marginBottom: "20px" }}>
        <h3>Available Files:</h3>
        <select
          value={selectedFile}
          onChange={handleSelect}
          style={{
            width: "100%",
            maxWidth: "400px",
            padding: "8px 12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
            background: "#f9f9f9",
          }}
        >
          <option value="">-- Select a file --</option>
          {files.map((file, idx) => (
            <option key={idx} value={file.name || file}>
              {file.name || file}
            </option>
          ))}
        </select>
        <button
          style={{
            marginTop: "10px",
            padding: "8px 12px",
            borderRadius: "6px",
            cursor: "pointer",
          }}
          onClick={confirmSelection}
        >
          Confirm Selection
        </button>
      </div>

      <hr />

      {/* Activity Log */}
      <div>
        <h3>Activity Log</h3>
        <div
          style={{
            maxHeight: "350px",
            overflowY: "auto",
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "10px",
            background: "#f9f9f9",
          }}
        >
          {logs.length === 0 && <p>No activity yet</p>}
          {logs.map((log, index) => {
            const [fileName, type, time] = log.split("|");
            const isConfirm = type === "CONFIRMED";

            return (
              <div
                key={index}
                style={{
                  marginBottom: "10px",
                  padding: "8px",
                  borderRadius: "6px",
                  backgroundColor: isConfirm ? "#dcf8c6" : "#ffffff",
                  textAlign: isConfirm ? "right" : "left",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <strong>{fileName}</strong>
                  <div style={{ fontSize: "12px", color: "gray" }}>{time}</div>
                  <div>{isConfirm ? "You confirmed this file" : "Receiver opened this file"}</div>
                </div>
                {isConfirm && (
                  <button
                    onClick={() => deleteConfirm(fileName, time)}
                    style={{
                      marginLeft: "10px",
                      background: "#ff4d4d",
                      color: "white",
                      border: "none",
                      padding: "6px 10px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      flexShrink: 0,
                    }}
                  >
                    Delete
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}



// STICKER GENERATOR COMPONENT
function StickerGenerator(props) {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
  document.title = "OB - Sticker"; // any name you like
}, []);


  useEffect(() => {
  const ua = navigator.userAgent;

  const isDesktop =
    ua.includes("Windows") || ua.includes("Macintosh") || ua.includes("Linux x86_64");

  if (!isDesktop) {
    setIsMobile(true);
  }
}, []);


  // 🚫 Block Mobile Devices
  if (isMobile) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px"
      }}>
        <div>
          <h2>🖥 Sticker Printing is available only on Desktop</h2>
          <button
            style={{ marginTop: "20px", padding: "10px 20px" }}
            onClick={() => props.goToPage('dashboard')}
          >
            ⬅ Back to Dashboard
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="app">
      <div className="top-nav">
        <button
          className="back-btn"
          onClick={() => props.goToPage('dashboard')}
        >
          ⬅ Back
        </button>
      </div>

      <div className="form-box">
        <div className="form-title">
          <label className="form-txt">OUTBOUND STICKER</label>
        </div>
        <label>STORE NAME</label>
        <select value={props.storeName} onChange={props.handleStoreChange}>
          <option value="">-- Select Store --</option>
          <option value="TAMBARAM">TAMBARAM</option>
          <option value="PALLIKARANAI">PALLIKARANAI</option>
          <option value="T - NAGAR">T - NAGAR</option>
          <option value="AVADI">AVADI</option>
          <option value="USMAN ROAD">USMAN ROAD</option>
          <option value="KEELKATTALAI">KEELKATTALAI</option>
          <option value="OTHER">Other (Type manually)</option>
        </select>
        {props.showStoreInput && (
          <input
            type="text"
            value={props.storeInput}
            onChange={(e) => props.setStoreInput(e.target.value)}
            placeholder="Type store name"
          />
        )}
        {/* Other inputs */}
        <label>STO NO</label>
        <input
          value={props.sto}
          onChange={(e) => props.setSto(e.target.value)}
        />
        <label>CATEGORY</label>
<select
  value={props.category}
  onChange={(e) => props.setCategory(e.target.value)}
>
  <option value="">-- Select Category --</option>
  {props.categoryList.map((cat, index) => (
    <option key={index} value={cat}>
      {cat}
    </option>
  ))}
  <option value="MANUAL">Manual (Type Category)</option>
</select>

{props.category === "MANUAL" && (
  <input
    type="text"
    placeholder="Enter Category"
    onChange={(e) => props.setCategory(e.target.value)}
  />
)}

        <label>DATE</label>
        <input
          value={props.date}
          onChange={(e) => props.setDate(e.target.value)}
        />
        <label>QTY</label>
        <input
          value={props.qty}
          onChange={(e) => props.setQty(e.target.value)}
        />
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-end' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <label>TOTAL BUNDLE</label>
            <input
              type="number"
              value={props.bundle}
              onChange={(e) => props.setBundle(Number(e.target.value))}
            />
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <label>RPN</label>
            <select value={props.rpnSelect} onChange={props.handleRpnChange}>
              <option value="">-- Select RPN --</option>
              <option value="STOS1">STOS1</option>
              <option value="STOS2">STOS2</option>
              <option value="STOS3">STOS3</option>
              <option value="MANUAL">Manual</option>
            </select>
            {props.rpnSelect === 'MANUAL' && (
              <input
                type="text"
                value={props.rpn}
                onChange={(e) => props.setRpn(e.target.value)}
                placeholder="Enter RPN"
              />
            )}
          </div>
        </div>
        <button className="generate-btn" onClick={props.generateStickers}>
          Generate Stickers
        </button>
       {props.showPrintBtn && (
  <div >
    <button className='print-btn' onClick={() => window.print()}>
      PRINT TEST BUTTON
    </button>
  </div>
)}

      </div>
      <div className="preview-container">
        <div className="preview-inner" id="printArea"></div>
      </div>
    </div>
  );
}

// QR VALIDATION COMPONENT


function QRValidation(props) {

  useEffect(() => {
    document.title = "OB - QR & BDLE VAL";
  }, []);

  const totalBundles = props.items.reduce((acc, b) => acc + b.total, 0);
  const totalScanned = props.items.reduce((acc, b) => acc + b.scannedBundles.length, 0);
  const remaining = totalBundles - totalScanned;
  const allScanned = remaining === 0 && totalBundles > 0;

  return (
    <div style={{
      padding: "15px",
      maxWidth: "1000px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif"
    }}>

      {/* Header */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
      }}>
        <h2 style={{ flex: "1 1 auto" }}>
          QR Bundle Validation
        </h2>

        <button onClick={() => props.goToPage("dashboard")}>
          ⬅ Back
        </button>
      </div>

      <hr />

      {/* Store Section */}
      <div style={{
        marginBottom: "20px",
        display: "flex",
        flexWrap: "wrap",
        gap: "10px"
      }}>

        <div style={{ flex: "1 1 300px" }}>
          <label><b>Store Name</b></label>
          <select
  value={props.qrStoreSelect}
  onChange={props.handleQrStoreChange}
  disabled={props.locked}
  style={{
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  }}
>
  <option value="">-- Select Store --</option>
  <option value="TAMBARAM">TAMBARAM</option>
  <option value="PALLIKARANAI">PALLIKARANAI</option>
  <option value="T - NAGAR">T - NAGAR</option>
  <option value="AVADI">AVADI</option>
  <option value="USMAN ROAD">USMAN ROAD</option>
  <option value="KEELKATTALAI">KEELKATTALAI</option>
  <option value="MANUAL">Manual (Type Store)</option>
</select>

{props.qrStoreSelect === "MANUAL" && (
  <input
    type="text"
    value={props.qrStoreManual}
    disabled={props.locked}
    onChange={(e) => {
      props.setQrStoreManual(e.target.value);
      props.setQrStore(e.target.value);
    }}
    placeholder="Enter Store Name"
    style={{
      width: "100%",
      padding: "10px",
      marginTop: "8px",
      borderRadius: "6px",
      border: "1px solid #ccc"
    }}
  />
)}

        </div>

        <div style={{ flex: "1 1 200px" }}>
          <label><b>Tag No</b></label>
          <input
            type="text"
            value={props.tagNo}
            onChange={(e) => props.setTagNo(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "5px",
              borderRadius: "6px",
              border: "1px solid #ccc"
            }}
          />
        </div>

      </div>

      {/* Scan Input */}
      <div style={{
        textAlign: "center",
        marginBottom: "20px"
      }}>
        <input
          id="qrInput"
          placeholder="Scan QR Bundle Here"
          autoFocus
          value={props.qrInput}
          onChange={(e) => props.setQrInput(e.target.value)}
          onKeyDown={props.handleQRKeyPress}
          style={{
            width: "100%",
            maxWidth: "500px",
            padding: "15px",
            fontSize: "18px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            textAlign: "center"
          }}
        />

        {props.errorMsg && (
          <div style={{
            marginTop: "10px",
            color: "red",
            fontWeight: "bold"
          }}>
            {props.errorMsg}
          </div>
        )}
      </div>

      {/* Counters */}
      <div style={{
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
        gap: "10px",
        marginBottom: "20px"
      }}>

        <div style={{
          padding: "10px",
          background: "#f0f0f0",
          borderRadius: "6px",
          flex: "1 1 30%",
          textAlign: "center"
        }}>
          <strong>Total:</strong> {totalBundles}
        </div>

        <div style={{
          padding: "10px",
          background: "#d4edda",
          borderRadius: "6px",
          flex: "1 1 30%",
          textAlign: "center"
        }}>
          <strong>Scanned:</strong> {totalScanned}
        </div>

        <div style={{
          padding: "10px",
          background: "#f8d7da",
          borderRadius: "6px",
          flex: "1 1 30%",
          textAlign: "center"
        }}>
          <strong>Remaining:</strong> {remaining}
        </div>

      </div>

      {/* Buttons */}
      <div style={{
        textAlign: "center",
        marginBottom: "20px",
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        flexWrap: "wrap"
      }}>

        <button onClick={props.downloadExcel}>
          Download Excel
        </button>

        {allScanned && (
          <button
            onClick={props.submitToServer}
            style={{
              backgroundColor: "#28a745",
              color: "white",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none"
            }}
          >
            Submit Validation
          </button>
        )}

        <button onClick={props.adminUnlock}>
          Action
        </button>

      </div>

      {/* Table */}
      <div style={{
        height: "60vh",
        minHeight: "300px",
        overflowY: "auto",
        overflowX: "auto",
        border: "1px solid #ccc",
        borderRadius: "6px"
      }}>

        <table style={{
          width: "100%",
          borderCollapse: "collapse",
          minWidth: "600px"
        }}>

          <thead style={{
            position: "sticky",
            top: 0,
            background: "#f0f0f0"
          }}>
            <tr>
              <th>S.No</th>
              <th>STO</th>
              <th>Category</th>
              <th>RPN</th>
              <th>Total</th>
              <th>Scanned</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {props.items.map((i, idx) => {

              const complete = i.scannedBundles.length === i.total;

              return (
                <tr
                  key={idx}
                  style={{
                    backgroundColor: complete
                      ? "#d4edda"
                      : "#f8d7da"
                  }}
                >

                  <td>{i.serial}</td>
                  <td>{i.STO}</td>
                  <td>{i.Category}</td>
                  <td>{i.RPN}</td>
                  <td>{i.total}</td>
                  <td>{i.scannedBundles.length}</td>

                  <td>
                    {complete
                      ? "✅ Complete"
                      : `${i.scannedBundles.length}/${i.total} scanned`}
                  </td>

                  <td>
                    <button
                      onClick={() => props.deleteRow(idx)}
                      disabled={!props.adminMode}
                    >
                      Delete
                    </button>
                  </td>

                </tr>
              );
            })}

          </tbody>

        </table>

      </div>

    </div>
  );
}




export default App;
